var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOfficialLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 0H2.49219C1.11719 0 0 1.13281 0 2.52344V32.4766C0 33.8672 1.11719 35 2.49219 35H32.5C33.875 35 35 33.8672 35 32.4766V2.52344C35 1.13281 33.875 0 32.5 0ZM10.5781 30H5.39062V13.2969H10.5859V30H10.5781ZM7.98438 11.0156C6.32031 11.0156 4.97656 9.66406 4.97656 8.00781C4.97656 6.35156 6.32031 5 7.98438 5C9.64062 5 10.9922 6.35156 10.9922 8.00781C10.9922 9.67188 9.64844 11.0156 7.98438 11.0156ZM30.0234 30H24.8359V21.875C24.8359 19.9375 24.7969 17.4453 22.1406 17.4453C19.4375 17.4453 19.0234 19.5547 19.0234 21.7344V30H13.8359V13.2969H18.8125V15.5781H18.8828C19.5781 14.2656 21.2734 12.8828 23.7969 12.8828C29.0469 12.8828 30.0234 16.3438 30.0234 20.8438V30Z",
    fill: "#AAAAAA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfficialLinkedin);
export default __webpack_public_path__ + "static/media/officialLinkedin.67e535f5.svg";
export { ForwardRef as ReactComponent };